/**
 * @generated SignedSource<<61eb2e111d18cbd618a7216a7120ee0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProfileMutationsDeleteOrganizationMemberMutation$variables = {
  id: string;
};
export type ProfileMutationsDeleteOrganizationMemberMutation$data = {
  readonly deleteOrganizationMember: {
    readonly id: string;
  };
};
export type ProfileMutationsDeleteOrganizationMemberMutation = {
  response: ProfileMutationsDeleteOrganizationMemberMutation$data;
  variables: ProfileMutationsDeleteOrganizationMemberMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id',
          },
        ],
        concreteType: 'OrganizationMember',
        kind: 'LinkedField',
        name: 'deleteOrganizationMember',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'ProfileMutationsDeleteOrganizationMemberMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'ProfileMutationsDeleteOrganizationMemberMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '1889715a79f293748b9b4f3730beca90',
      id: null,
      metadata: {},
      name: 'ProfileMutationsDeleteOrganizationMemberMutation',
      operationKind: 'mutation',
      text: 'mutation ProfileMutationsDeleteOrganizationMemberMutation(\n  $id: ID!\n) {\n  deleteOrganizationMember(id: $id) {\n    id\n  }\n}\n',
    },
  };
})();

(node as any).hash = '9805a3413b6feb15f6fabc1279e9d245';

export default node;
